// extracted by mini-css-extract-plugin
module.exports = {"castCrewComponentWrapper":"fE","castCrewHeader":"fF","castCrewBody":"fG","castCrewTitle":"fH","slipnslideArrow":"fI"};